export enum AnomalyStatus {
  New = 'new',
  Reviewed = 'reviewed',
}
